import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useValidationError } from '../../hooks/useValidationError';

export const ValidationError: React.FC<EmptyProps> = () => {
	const { error } = useValidationError();
	if (!error) return null;
	return (
		<Alert
			variant="error"
			heading={<Translate value="corgi.co.promote.validation.amount.not_selected.heading" />}
			data-qa="invalid-amount-error-message"
		>
			{error}
		</Alert>
	);
};
